<form class="custom-forms form-horizontal" action="#" method="POST" novalidate="novalidate" id="form_body" [formGroup]="assetFiltter">
    <div class="row generalSearchSection" >
        <div class="col-lg-12 row">
            <div class="col-lg-6 d-flex reportFilter">
                    <!-- Facility Department multiselect -->
                    <div class="col-lg-6 d-flex pull-left mr-2">
                        <ng-multiselect-dropdown style="width: 100%;" class="multidrop" (keydown.enter)="$event.preventDefault()" name="Facility Department" 
                        [placeholder]="'Facility Department '" [data]="facility_department" formControlName="FacilityDepart"
                        [settings]="dropdownFacilityDepartSettings" (onSelect)="onItemSelectFacilityDepart($event)"
                        (onSelectAll)="onSelectAllFacilityDepart($event)" (onDeSelect)="onItemDeSelectFacilityDepart($event)"
                        (onDeSelectAll)="onItemDeSelectAllFacilityDepart($event)">
                      </ng-multiselect-dropdown>
                    </div>
                <!-- Asset Status multiselect -->
                <div class="col-lg-6 d-flex pull-left mr-2">
                    <ng-multiselect-dropdown style="width: 100%;" class="multidrop" (keydown.enter)="$event.preventDefault()"
                    [placeholder]="'Asset Status'" [settings]="dropdownAssetStatusSettings" formControlName="asset_status_id" [data]="asset_status_data"
                    (onSelect)="onItemSelectAssetStatus($event)" (onSelectAll)="onSelectAllAssetStatus($event)" (onDeSelect)="onItemDeSelectAssetStatus($event)"
                    (onDeSelectAll)="onItemDeSelectAllAssetStatus($event)">
                    </ng-multiselect-dropdown>
                </div>
            </div>
                <div class="col-lg-2"></div>
  
                <div class="col-lg-4 d-flex mr-2 row justify-content-end">
                    <!-- asset status report view button -->
                    <button type="button" class="views" (click)="getAssetStatusReport(2,1,selectedItemsPerPage1,search_value)">{{'RAISETCKT.VIEW'|translate}}<img class="export-img"
                        src="assets/media/icons/png/eye.png"></button>
                    <!-- asset status report Export button (click)="assetCountExport()" -->
                    <button type="button" class="export ml-2" (click)="exportAsAssetReport()">{{'SITE.EXPORT'|translate}}<img class="export-img"
                        src="assets/media/icons/png/xlsx.png"></button>
                    <!-- asset status report reset button -->
                    <button type="button" class="btn btnFill ml-2" (click)="reset()">Reset</button>
                </div>
            <!-- </div> -->
        </div>
    </div>
</form>
<div class="row" >
    <div class="col-lg-9"></div>
    <div class="col-lg-3">
            <div class="search-container">
              <input type="text" placeholder="search here" name="search" class="form-control" [(ngModel)]="search_value"/>
              <button (click)="search(1,search_value,selectedItemsPerPage1,1)" class="search-button"></button>
            </div>
    </div>
    <div class="col-lg-9"></div>
    <div class="col-lg-3" style="color: brown;" *ngIf="searchError!=''">
        {{searchError}}
    </div> 
</div>
<!-- asset history report filter buttons end-->
<div>
    <div >
            <div class="table-responsive GeneralTable text-nowrap">
                <table id="normalAssetDatatables" class="table-bordered datatable w-auto mw-100" >
                    <thead>
                        <tr>
                            <!-- <th>{{'NEW_SUBSCRIPTION.SERIAL_NO' | translate}}</th>
                            <th>{{'AMC.TAB_SERIAL' | translate}} </th>
                            <th>Equipment Name</th>
                            <th>Facility Name</th>
                            <th>Asset Value</th>
                            <th>Device Class</th>
                            <th>Contract</th>
                            <th>Expiry Date</th>
                            <th>Asset Status</th>
                            <th>Last Update</th>
                            <th>Asset History</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <!-- values from the api.For loop to populate the datas -->
                        <tr *ngFor="let item of assetStatusReportData| paginate: { itemsPerPage: selectedItemsPerPage1, currentPage: currentPage1, totalItems: totalRecords1 };let i = index;">
                        <!-- <td class="datatable-center">{{i+1}}</td>
                        <td class="linkButton" (click)="get_barocde_details(item.barcode)">{{item.barcode}}</td>
                        <td>{{item.equipment_name}}</td>
                        <td>{{item.facility_name}}</td>
                        <td>{{item.asset_value}}</td>
                        <td>{{item.facility_device_class}}</td>
                        <td>{{item.contract_type}}</td>
                        <td>{{item.expiry_day}}</td>
                        <td>{{item.asset_status}}</td>
                        <td>{{item.update_at}}</td>
                        <td class="datatable-center">
                            <button class="btn btnFill ml-2 disabledsubmit" (click)='getAssetHistory(1,item.barcode)'>View</button>
                        </td>   -->
                        </tr>
                    </tbody>
                </table>
                <div class="row">
                    <div class="col-sm-6 entries"> <!-- Showing X to Y of Z entries -->
                        <p class="entries">Showing {{ startRecord1 }} to {{ endRecord1 }} of {{ totalRecords1 }} entries
                        </p>
                    </div>
                    <div class="col-sm-6 text-right"> <!-- Pagination Controls -->
                        <pagination-controls (pageChange)="pagechange($event,selectedItemsPerPage1,search_value)"
                            [totalItems]="totalRecords1" [itemsPerPage]="itemsPerPage1"></pagination-controls>
                    </div>
                </div>
            </div>
        <!-- </ng-template> -->
    </div>
    <div *ngIf="showAssetHistory">
        <div class="table-responsive GeneralTable text-nowrap" *ngIf="!pagination_flag;else normalTemplate">
            <table id="datatables" datatable="ng" class="table-bordered datatable w-auto mw-100" [dtOptions]="dtOptions" >
                <thead>
                    <tr>
                        <th>{{'RAISETCKT.SE_NO' | translate}} </th>
                        <th>MPT ID</th>
                        <th>{{'PRODUCTMASTER.BARCODE'| translate}}</th>
                        <th>BME</th>
                        <th>Service Group</th>
                        <th>Raised date</th>
                        <th>Completed date</th>
                        <th>Ticket Age </th>
                        <th>Resolution Summary</th>
                        <th>Attachment</th>
                        <th>Status </th>
                    </tr>
                </thead>
                <tbody *ngIf="assetHistoryData?.length != 0">
                    <!-- values from the api.For loop to populate the datas -->
                    <tr *ngFor="let item of assetHistoryData;let i=index">
                        <td class="datatable-center">{{i+1}}</td>
                        <td><a class="button" (click)="get_ticket_details(item.MPT_id,view_tcktdetails)"  data-placement="bottom" ngbTooltip="View Details">{{ item.MPT_id }}</a></td>
                        <td class="linkButton" (click)="get_barocde_details(item.Barcode)">{{item.Barcode}}</td>
                        <td><a class="button" (click)="get_technician_details(item.MPT_id,item.BME_id,view_techniciandetails);"  data-placement="bottom" ngbTooltip="View Details">{{ item.BME_id }}</a></td>
                        <td>{{item.work_type}}</td>
                        <td>{{item.raised_date}}</td>
                        <td>{{item.completed_date}}</td>
                        <!-- <td>{{item.ticket_age}} Days</td> -->
                        <td *ngIf="item.ticket_age == '-'" style="color: black;">{{item.ticket_age}}</td>
                        <td *ngIf="item.ticket_age <=5" style="color: 255EBB;">{{item.ticket_age}} Days</td>
                        <td *ngIf="item.ticket_age <=7 && item.ticket_age >5" style="color: DFBD07;">{{item.ticket_age}} Days</td>
                        <td *ngIf="item.ticket_age >=8" style="color: C00712;">{{item.ticket_age}} Days</td>
                        <td>{{item.resolution_summary}}</td>
                        <td>{{item.attachment}}</td>
                        <td>{{item.status}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        
        <ng-template #normalTemplate>
            <div class="table-responsive GeneralTable text-nowrap">
                <table id="normalDatatables" class="table-bordered datatable w-auto mw-100" >
                    <thead>
                        <tr>
                            <th>{{'RAISETCKT.SE_NO' | translate}} </th>
                            <th>MPT ID</th>
                            <th>{{'PRODUCTMASTER.BARCODE'| translate}}</th>
                            <th>BME</th>
                            <th>Service Group</th>
                            <th>Raised date</th>
                            <th>Completed date</th>
                            <th>Ticket Age </th>
                            <th>Resolution Summary</th>
                            <th>Attachment</th>
                            <th>Status </th>
                        </tr>
                    </thead>
                    <tbody *ngIf="assetHistoryData?.length != 0">
                        <!-- values from the api.For loop to populate the datas -->
                        <tr *ngFor="let item of assetHistoryData;let i=index">
                            <td class="datatable-center">{{i+1}}</td>
                            <!-- <td>{{item.MPT_id}}</td> -->
                            <td><a class="button" (click)="get_ticket_details(item.MPT_id,view_tcktdetails)"  data-placement="bottom" ngbTooltip="View Details">{{ item.MPT_id }}</a></td>
                            <td class="linkButton" (click)="get_barocde_details(item.Barcode)">{{item.Barcode}}</td>
                            <!-- <td>{{item.BME_id}}</td> -->
                            <td><a class="button" (click)="get_technician_details(item.MPT_id,item.BME_id,view_techniciandetails);"  data-placement="bottom" ngbTooltip="View Details">{{ item.BME_id }}</a></td>
                            <td>{{item.work_type}}</td>
                            <td>{{item.raised_date}}</td>
                            <td>{{item.completed_date}}</td>
                            <td *ngIf="item.ticket_age_type== 'Str'" style="color: black;">{{item.ticket_age}}</td>
                            <td *ngIf="item.ticket_age <=5 && item.ticket_age_type =='Int'" style="color: #255EBB;">{{item.ticket_age}} Days</td>
                            <td *ngIf="item.ticket_age <=7 && item.ticket_age >5 && item.ticket_age_type == 'Int'" style="color: #DFBD07;">{{item.ticket_age}} Days</td>
                            <td *ngIf="item.ticket_age >=8 && item.ticket_age_type =='Int'" style="color: #C00712;">{{item.ticket_age}} Days</td>
                            <td>{{item.resolution_summary}}</td>
                            <td>{{item.attachment}}</td>
                            <td>{{item.status}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-template>
        <br>
        <div class="row generalSearchSection">
            <div class="col-md-12  multibtns ">                             
                <button type="button" class="views" style="padding: 5px 15px !important"  (click)="backPage()">Back</button>
            </div>
        </div>
        <!-- <div class="col-md-12 d-flex align-items-right justify-content-right">
            <button type="button" class="views" (click)="backPage()">Back</button>
        </div> -->
    </div>
</div>